// src/index.js
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

/* Optional: import FontAwesome globally (skip if loaded in index.html) */
// import '@fortawesome/fontawesome-free/css/all.min.css';

/* ================================================================== */
/* Full-screen loading spinner                                         */
/* ================================================================== */

const FullScreenLoader = () => (
  <div
    className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900"
    role="status"
    aria-live="polite"
    aria-label="Loading application"
  >
    <div className="text-center">
      <div className="w-12 h-12 mx-auto border-4 border-orange border-t-transparent rounded-full animate-spin motion-reduce:animate-none" />
      <p className="text-xs text-gray-500 dark:text-gray-400 mt-3">
        Loading…
      </p>
    </div>
  </div>
);

/* ================================================================== */
/* Guarded Error Boundary                                              */
/* Wraps children only if the component resolves; otherwise renders    */
/* children directly so the app never fails to mount.                 */
/* ================================================================== */

const SafeErrorBoundary = ({ children }) => {
  if (!ErrorBoundary || typeof ErrorBoundary !== 'function') {
    // Fallback if the component failed to import
    if (process.env.NODE_ENV !== 'production') {
      console.warn(
        '[index.js] ErrorBoundary not available — rendering without it.',
      );
    }
    return children;
  }
  return <ErrorBoundary>{children}</ErrorBoundary>;
};

/* ================================================================== */
/* Mount                                                               */
/* ================================================================== */

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <SafeErrorBoundary>
      <Suspense fallback={<FullScreenLoader />}>
        <App />
      </Suspense>
    </SafeErrorBoundary>
  </React.StrictMode>,
);

/* ================================================================== */
/* Optional: register service worker (only if you have one in /public) */
/* ================================================================== */

// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// serviceWorkerRegistration.register();